import { sva, css } from '@agapi/ui/panda/css';

export const backInStockFormStyles = sva({
  slots: [
    'card',
    'successContainer',
    'successIcon',
    'successContent',
    'successTitle',
    'successMessage',
    'headerContainer',
    'headerContent',
    'headerTitle',
    'headerDescription',
    'formContainer',
    'hiddenFormTitle',
    'emailFieldContainer',
    'hiddenErrorMessage',
    'submitButton',
    'hiddenStatusMessage'
  ],
  base: {
    card: {
      borderRadius: 'calc(token(radii.surface.md) - token(spacing.4))'
    },

    successContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4',
      alignItems: 'center',
      textAlign: 'center'
    },

    successIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      w: 'items.xl',
      h: 'items.xl',
      borderRadius: 'full',
      bg: 'feedback.success.background',
      color: 'feedback.success.foreground'
    },

    successContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2',
      alignItems: 'center'
    },

    successTitle: {
      fontSize: 'lg',
      fontWeight: 'semibold',
      color: 'feedback.success.foreground'
    },

    successMessage: {
      fontSize: 'sm',
      color: 'text.subdued'
    },

    headerContainer: {
      display: 'flex',
      gap: '3',
      alignItems: 'center'
    },

    headerContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1',
      flex: '1'
    },

    headerTitle: {
      fontSize: 'md',
      fontWeight: 'semibold',
      color: 'text.primary'
    },

    headerDescription: {
      fontSize: 'sm',
      color: 'text.subdued',
      lineHeight: 'relaxed'
    },

    formContainer: {
      display: 'flex',
      direction: { base: 'column', md: 'row' },
      gap: { base: '3', md: '2' },
      width: '100%',
      alignItems: { base: 'stretch', md: 'flex-end' }
    },

    hiddenFormTitle: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    },

    emailFieldContainer: {
      flex: { base: '1', md: '1' },
      minWidth: { base: '100%', md: '200px' }
    },

    hiddenErrorMessage: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    },

    submitButton: {
      display: 'flex',
      width: { base: '100%', md: 'auto' },
      minWidth: { base: 'auto', md: '120px' },
      height: '50px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '2',
      flexShrink: 0
    },

    hiddenStatusMessage: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    }
  }
});

// Style objects for CSS props
export const cardStyles = css.raw({
  borderRadius: 'calc(token(radii.surface.md) - token(spacing.4))'
});

export const submitButtonStyles = css.raw({
  display: 'flex',
  width: { base: '100%', md: 'auto' },
  minWidth: { base: 'auto', md: '120px' },
  height: '50px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2',
  flexShrink: 0
});
